export default __webpack_public_path__ + "static/media/flag-hkg.8ab7f441.png";